export default __webpack_public_path__ + "assets/841f801885e0adc2abf36bc9d11c5243.png";